import { Announcement } from '@mui/icons-material';
import { Badge } from '@mui/material';
import { useEffect, useState } from 'react';
import { useChatContext } from 'stream-chat-react';

export default function StreamChatMenuIcon({ isBottom }: { isBottom: boolean }) {
  const { client } = useChatContext();
  const [unreadCount, setUnreadCount] = useState<number>(0);

  useEffect(() => {
    if (!client) return;
    async function updateUnreadCount() {
      const localUnreadCount = await client.getUnreadCount();
      setUnreadCount(localUnreadCount.total_unread_count);
    }
    void updateUnreadCount();
  }, [client]);

  if (!client) {
    return <Announcement fontSize={isBottom ? 'small' : 'medium'} />;
  }

  client.on((event) => {
    const { type } = event;
    const selfMadeEvent = event.user?.id === client.userID;
    if ((selfMadeEvent && type === 'notification.mark_read') || (!selfMadeEvent && type === 'message.new')) {
      const totalCount = event.total_unread_count;
      if (typeof totalCount === 'number') {
        setUnreadCount(totalCount);
      }
    }
  });

  return unreadCount > 0 ? (
    <Badge color="error" variant="dot">
      <Announcement fontSize={isBottom ? 'small' : 'medium'} />
    </Badge>
  ) : (
    <Announcement fontSize={isBottom ? 'small' : 'medium'} />
  );
}
